import { Controller, UseFormReturn } from "react-hook-form";
import LassoSelect from "../../LassoSelect";
import { SelectField } from "../DynamicFormTypes";

type Props = {
    field: SelectField;
    form: UseFormReturn;
}

const SelectInput = ({ field, form }: Props) => {
    const { name, type, label, required = false, validationRules, defaultValue, placeholder = "", options = [] } = field;
    const { errors } = form.formState;
    return (
        <Controller
            control={form.control}
            name={name}
            rules={validationRules}
            defaultValue={defaultValue}
            render={({ field }) =>
                <LassoSelect
                    type={type}
                    label={label}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    fullWidth
                    required={required}
                    error={name in errors}
                    options={options}
                    {...field}
                />
            }
        />
    )
}
export default SelectInput;